<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <transition :name="transitionName">
        <router-view />
      </transition>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.meta.index && from.meta.index && to.meta.index > from.meta.index) {
          this.transitionName = 'slideright'
        } else if (to.meta.index && from.meta.index && to.meta.index < from.meta.index) {
          this.transitionName = 'slideleft'
        } else {
          this.transitionName = 'slideright'
        }
        document.title = to.meta.documentTitle ? to.meta.documentTitle : '同步课堂_智慧树'
      },
      immediate: true
    }
  },
  data() {
    return {
      transitionName: '',
      zhCN
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // min-width: 1366px;
}
</style>



